import React from 'react'
import { Button } from 'antd'
import { DownloadOutlined, FilePdfOutlined, FilePptOutlined } from '@ant-design/icons'
import './ExportButtons.scss'

// One look/UX for CSV / PDF / PPTX exports across Summary and Metrics. Pass the handlers;
// omit one to hide that button.
export const ExportButtons = ({ onCsv, onPdf, onPptx, disabled = false, loading = {} }) => (
  <div className="rz-exports">
    {onCsv && <Button size="small" icon={<DownloadOutlined />} onClick={onCsv} disabled={disabled} loading={loading.csv}>CSV</Button>}
    {onPdf && <Button size="small" icon={<FilePdfOutlined />} onClick={onPdf} disabled={disabled} loading={loading.pdf}>PDF</Button>}
    {onPptx && <Button size="small" icon={<FilePptOutlined />} onClick={onPptx} disabled={disabled} loading={loading.pptx}>PPTX</Button>}
  </div>
)

export default ExportButtons
